require("../scss/index.scss");
require("es6-object-assign").polyfill();

(window.$ = window.jQuery = require("jquery")), require("jquery-ui");

require("./components/autofill.js");
require("./vendor/jquery.rateit.min.js");

require("./pages/online-form.js");
require("./pages/online-form-manager.js");
require("./components/online-form-popups.js");
require("./pages/get-connected-form.js");
require("./pages/form-recaptcha-validation.js");

require("./components/global-notices.js");
require("./components/navigation.js");
// require("./components/responsive-images.js");
require("./components/homepage-slider.js");
require("./components/excanvas.js");
require("./components/ios-prompt.js");
require("./components/confirmation-button.js");
require("./components/range-field.js");
require("./components/checkbox-field.js");
require("./components/address-autocomplete-field.js");
require("./components/dependencies-field.js");
require("./components/datepicker-field.js");
require("./components/notifications.js");
require("./components/accordion.js");
require("./components/rating.js");
require("./components/mainsite-popups.js");
require("./components/resources.js");
require("./components/contact-page.js");
require("./components/outages.js");
require("./components/animation.js");
require("./components/get-connected-form.js");
require("./components/content-button.js");
require("./components/content-video-embeds.js");
require("./components/content-image-alignment.js");
require("./components/report-request-questions.js");
require("./components/recaptcha-jump.js");
require("./components/anchor-offset.js");
require("./components/accordion-section-header.js");
require("./components/page-accordion.js");
require("./components/icp-retailer-field.js");
